import React, { FC } from "react";
import { IconType } from "./types";
import { COLOR_GREY_8 } from "../colors";

export const LogOutIcon: FC<IconType> = ({ color = COLOR_GREY_8 }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 5H5V19H11C11.55 19 12 19.45 12 20C12 20.55 11.55 21 11 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H11C11.55 3 12 3.45 12 4C12 4.55 11.55 5 11 5ZM17.86 8.86L20.65 11.65C20.84 11.84 20.84 12.16 20.64 12.35L17.85 15.14C17.54 15.46 17 15.24 17 14.79V13H10C9.45 13 9 12.55 9 12C9 11.45 9.45 11 10 11H17V9.21C17 8.76 17.54 8.54 17.86 8.86Z"
      fill={color}
    />
  </svg>
);
